import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogInIcon } from 'lucide-react';
import { LoadingScreen } from '../components/LoadingScreen';
import { useAuth } from '../contexts/AuthContext';
export function Login() {
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate loading time for dashboard data
    setTimeout(() => {
      login();
      navigate('/overview');
    }, 2000);
  };
  if (isLoading) {
    return <LoadingScreen data-id="element-7260" />;
  }
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex items-center justify-center px-4" data-id="element-7261">
      <div className="max-w-md w-full" data-id="element-7262">
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8" data-id="element-7263">
          <div className="flex justify-center mb-6" data-id="element-7264">
            <img src="https://cdn.magicpatterns.com/uploads/txoPdqzVAwx9WbLZTFyv98/alliancelogo.svg" alt="Alliance Bank" className="h-20 w-auto" data-id="element-7265" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-2" data-id="element-7266">
            Welcome Back
          </h2>
          <p className="text-gray-600 text-center mb-8" data-id="element-7267">
            Sign in to your account to continue
          </p>
          <form onSubmit={handleLogin} className="space-y-6" data-id="element-7268">
            <div data-id="element-7269">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7270">
                Email Address
              </label>
              <input type="email" placeholder="simon.verraest@alliancebank.com.my" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003366] focus:border-[#003366] outline-none transition-colors" data-id="element-7271" />
            </div>
            <div data-id="element-7272">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7273">
                Password
              </label>
              <input type="password" placeholder="••••••••" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003366] focus:border-[#003366] outline-none transition-colors" data-id="element-7274" />
            </div>
            <div className="flex items-center justify-between" data-id="element-7275">
              <label className="flex items-center" data-id="element-7276">
                <input type="checkbox" className="h-4 w-4 text-[#003366] focus:ring-[#003366] border-gray-300 rounded" data-id="element-7277" />
                <span className="ml-2 text-sm text-gray-600" data-id="element-7278">Remember me</span>
              </label>
              <button type="button" className="text-sm text-[#003366] hover:text-[#002244] font-medium" data-id="element-7279">
                Forgot password?
              </button>
            </div>
            <button type="submit" className="w-full bg-[#003366] hover:bg-[#002244] text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center" data-id="element-7280">
              <LogInIcon size={18} className="mr-2" data-id="element-7281" />
              Sign In
            </button>
          </form>
          <div className="mt-6 text-center" data-id="element-7282">
            <p className="text-sm text-gray-600" data-id="element-7283">
              Don't have an account?{' '}
              <button className="text-[#003366] hover:text-[#002244] font-medium" data-id="element-7284">
                Contact Sales
              </button>
            </p>
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-7285">
          <p className="text-sm text-gray-500" data-id="element-7286">
            © 2025 Alliance Bank. All rights reserved.
          </p>
        </div>
      </div>
    </div>;
}